import { giftCardCurrencyAtom as m, clearCartItemsAtom as u, clearGiftCardsAtom as d } from "./index34.mjs";
import { searchResultsAtom as p } from "./index58.mjs";
import { searchCriteriaAtom as A, isCompleteSearchAtom as h } from "./index26.mjs";
import { selectedGiftCardAtom as S } from "./index64.mjs";
import { useSetAtom as t, useAtomValue as r } from "jotai";
import { useCallback as G, useEffect as y } from "react";
const V = (e = !1) => {
  const i = t(m), f = t(p), l = r(m), C = r(A), n = r(h), s = t(u), o = t(d), c = t(S), a = G(() => {
    e || s(), o(), c(null);
  }, [s, o, c, e]);
  return y(() => {
    a();
  }, [a]), {
    setGiftCardCurrency: i,
    setSearchResults: f,
    giftCardCurrency: l,
    searchInputs: C,
    isCompleteSearch: n
  };
};
export {
  V as useSearch
};
